import { FaWhatsapp } from "react-icons/fa";
import { cn } from "@/frontend/lib/utils";

interface WhatsAppBusinessIconProps {
  className?: string;
  badgeClassName?: string;
}

export function WhatsAppBusinessIcon({ className, badgeClassName }: WhatsAppBusinessIconProps) {
  return (
    <span
      className={cn(
        "relative inline-flex shrink-0 items-center justify-center text-[#25D366]",
        className
      )}
      aria-hidden="true"
    >
      <FaWhatsapp className="h-full w-full" />
      <span
        className={cn(
          "absolute -bottom-[8%] -right-[8%] flex items-center justify-center rounded-full bg-white font-black leading-none text-[#128C4A] ring-1 ring-[#128C4A]",
          badgeClassName
        )}
        style={{ width: "58%", height: "58%", fontSize: "46%" }}
      >
        B
      </span>
    </span>
  );
}
